// 通用的我的申请页面
import CommenApproval from "./commonApproval.js";
import Leave from "@/backup/ehr/leave.vue";
import ChangeSign from "@/backup/ehr/changeSign.vue";
import threeMonthReview from "@/backup/ehr/threeMonth.vue"; // 年假延期申请
import archivesBorrowing from "@/backup/ehr/archivesBorrowing.vue";

let obj = {
  ...CommenApproval,
  leaveOffice: {
    component: Leave,
    serviceUrl: "/treasure/ehr/leaveOffice/DoProcessInstance",
    recordUrl: "/treasure/ehr/leaveOffice/DoProcessInstance",
    method: "post",
    recordKey: "qh_hr_011_sta",
    data: [["instance_id", "instanceId"]],
    title: "离职申请详情",
    isNotCancel: true // 是否不显示撤销按钮 -- 我的申请页面
  },
  changeSign: {
    component: ChangeSign,
    serviceUrl: "/treasure/ehr/changeSign/DoProcessInstance",
    recordUrl: "/treasure/ehr/changeSign/DoProcessInstance",
    method: "post",
    recordKey: "qh_hr_020_sta",
    data: [["instance_id", "instanceId"]],
    title: "转签流程详情"
  },
  archivesBorrowing: {
    component: archivesBorrowing,
    serviceUrl: "/treasure/ehr/archivesBorrowing/DoProcessInstance",
    recordUrl: "/treasure/ehr/archivesBorrowing/DoProcessInstance",
    method: "post",
    recordKey: "qh_hr_017_sta",
    data: [["instance_id", "instanceId"]],
    title: "档案借阅详情",
    isNotCancel: true
  },
  threeMonthReview: {
    component: threeMonthReview,
    serviceUrl: "/treasure/ehr/threeMonthReview/DoProcessInstance",
    recordUrl: "/treasure/ehr/threeMonthReview/DoProcessInstance",
    method: "post",
    recordKey: "qh_005_sta",
    data: [["instance_id", "instanceId"]],
    title: "入职三个月回顾",
    path: "threeMonthReview"
  },
  // 先不删除， 历史数据库里 pageId 为 threeMonth，数据库里不再有此链接的时候 可删除
  threeMonth: {
    component: threeMonthReview,
    serviceUrl: "/treasure/ehr/threeMonthReview/DoProcessInstance",
    recordUrl: "/treasure/ehr/threeMonthReview/DoProcessInstance",
    method: "post",
    recordKey: "qh_005_sta",
    data: [["instance_id", "instanceId"]],
    title: "入职三个月回顾",
    path: "threeMonthReview"
  }
};
export default obj;
